import React from "react";
import { useContext, useEffect } from "react";
import SimpleContext from "./../context/SimpleContext";
import axios from "axios";
import { Config } from "@testing-library/react";
import config from "../../services/config.json";
import right from "../img/right.png";
import { useHistory } from "react-router";

const Rulls = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();
  //فراخانی وب سرویس قوانین و مقررات
  useEffect(() => {
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);
    const myheaders = {
      "atu-token": TimeHeader,
    };
    axios
      .get(`${context.baseUrlApiPakhsh}${config.userTerm}`, {
        headers: myheaders,
      })
      .then((response) => {
        if (parseInt(response.data.code) === 200) {
          context.setrullsText(response.data.response);
        } else if (parseInt(response.data.code) === 401) {
          context.setshowModalTime(true);
        }
      })
      .catch((er) => {
        console.log(er);
        if (context.showApplications.length > 0) {
          context.HandelShowContentPage("3");
        }
      });
  }, []);
  return (
    <div className="productsmain">
      <div className="otherPagesHeader">
        <div
          style={{
            width: "15%",
            display: "flex",
            justifyContent: "flex-start",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <img
            onClick={() => history.go(-1)}
            className="backIcon"
            src={right}
          />
        </div>
        <div
          style={{
            width: "70%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              margin: "0",
              fontWeight: "bold",
              fontSize: "14px",
              display: "flex",
              textAlign: "center",
              alignItems: "center",
              padding: "5px",
              color: "#000",
            }}
          >
            قوانین و مقررات
          </p>
        </div>
        <div style={{ width: "15%", visibility: "hidden" }}>
          <p>hiiii</p>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "60px",
          padding: "3%",
          textAlign: "right",
        }}
      >
        {context.rullsText.split("\r\n").map((item, key) => {
          return (
            <p style={{ fontWeight: "bold" }} key={key}>
              {item}
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default Rulls;
